export const ERRORS = {
  couldNotDeleteEditRevision: 'Failed to delete this revision',
  couldNotLoad: `Couldn't load`,
}
